export default __webpack_public_path__ + "static/layer5-event-hacktoberfest2023-a4577b0d646566630ca2e8caa0f7d9a9.png";